"use client"

import React from "react"
import AuthPage from "../templates/Auth/auth-template"
import AuthForm from "../organisms/AuthForm/auth-form"
import useLocaleStore from "@/app/stores/useLocaleStore"

const ForgotPasswordPage: React.FC = () => {
const locale = useLocaleStore((state) => state.locale)


  return (
    <AuthPage>
      <AuthForm
        mode="forgot-password"
        heading={locale === "en" ? "Forgot Password?" : "የይለፍ ቃል ረስተዋል"}
        buttonText={locale === "en" ? "Send Code" : "የመጀመሪያ ቃል ይላኩ"}
        secondaryLinkLabel={locale === "en" ? "Remember your password?" : "የይለፍ ቃልህን አስታውሃል?"}
        secondaryLinkText={locale === "en" ? "Log In" : "መግቢያ"}
        secondaryLinkHref="/auth/login"
      />
    </AuthPage>
  )
}

export default ForgotPasswordPage
